import { Badge } from "react-bootstrap";

// How long after a request's creation a missing status code still reads
// as "in flight". The api_requests row is inserted before the handler
// runs and only gets its status once the response is recorded, so a
// recent request with no status is simply not finished yet. Past this
// window the response is never coming (the handler crashed or the
// recorder never completed), and the badge says that instead.
const PENDING_WINDOW_SECONDS = 5 * 60;

export default function StatusBadge({
  statusCode,
  created,
}: {
  statusCode: number | null | undefined;
  created?: number;
}) {
  if (statusCode == null) {
    const isPending =
      created !== undefined &&
      Date.now() / 1000 - created < PENDING_WINDOW_SECONDS;

    return isPending ? (
      <Badge bg="light" text="dark">
        Pending
      </Badge>
    ) : (
      <Badge bg="warning" text="dark">
        No response
      </Badge>
    );
  }

  const isSuccess = statusCode >= 200 && statusCode < 300;

  const [bg, text] = isSuccess ? ["secondary", undefined] : ["warning", "dark"];

  return (
    <Badge bg={bg} text={text}>
      {statusCode}
    </Badge>
  );
}
